import React, { useState } from 'react';

type Props = {};

const AutomaticFundingPage = (props: Props) => {
  const [isFundingModalOpen, setIsFundingModalOpen] = useState(false);

  const handleOpenFundingModal = () => setIsFundingModalOpen(true);
  const handleCloseFundingModal = () => setIsFundingModalOpen(false);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '100%', margin: 'auto', backgroundColor: '#fff', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', height:'80%' }}>
     <h4 style={{fontSize:'13px'}}>Setup Automatic Funding Agreement</h4>
     <p style={{fontSize:'12px',color:'#FC7C7C'}}>You do not have any active payment sources to setup for automatic funding agreement.
     </p>
    
    <p style={{fontSize:'12px'}}>Supported automatic funding options:</p>
    <div style={{marginLeft:'30px'}}>
      <p  style={{fontSize:'12px'}}>1) Credit Cards (excluding "Instant Approval")</p>
      <p  style={{fontSize:'12px', marginTop:'-5px'}}>2) PayPal</p>
    </div>

    <p  style={{fontSize:'12px'}}>Click here to make an initial deposit using any of the above options and then return to this page to set it up as an automatic on.</p>
    </div>
  );
};

export default AutomaticFundingPage;



